import { render } from 'preact';

import '../scss/main.scss';

// Components.
import MapApp from './components/MapApp';

// Accepted map types from localized plugin settings.
const { mapTypes = [] } = window.strMapsSettings || {};

/**
 * Render the map application.
 *
 * @param target The target element to render the map application into.
 */
const renderMapApplication = ( target: HTMLElement ) => {
	// Get the map type from the data attribute.
	const type = target.getAttribute( 'data-type' );

	// Ensure the type of map is valid.
	if ( ! type || ! mapTypes.includes( type ) ) {
		// eslint-disable-next-line
		console.error(
			`Invalid type prop: ${ type }. Accepted types are: ${ mapTypes.join( ', ' ) }`
		);
		return;
	}

	render(
		<div class="str-maps__app">
			<MapApp mapType={ type } />
		</div>,
		target
	);
};

// Target element provided by the plugin's render_map method.
const target = document.getElementById( 'str-map-root' );

// Try to render if target element exists.
if ( target ) {
	renderMapApplication( target );
}
